import { render } from "./boyaaChinese.vue?vue&type=template&id=3a01ddf0&scoped=true"
import script from "./boyaaChinese.vue?vue&type=script&lang=js"
export * from "./boyaaChinese.vue?vue&type=script&lang=js"

import "./boyaaChinese.vue?vue&type=style&index=0&id=3a01ddf0&scoped=true&lang=css"

import exportComponent from "E:\\JzHyLyEdu\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a01ddf0"]])

export default __exports__